// eslint-disable-next-line import/no-cycle
import { 
  GetOperatorsList,
  AlterCustomerStatus,
  GetOperatorsListCSV
} from '@/api/operators-list';

export const fetchOperators = ({ commit, dispatch }, params) => {
  commit('CLEAR_MORE_OPERATORS');
  commit('OPERATORS_REQUEST_DISPATCH');

  dispatch('CheckAuth', null, {root: true})
    .then(() => {
      GetOperatorsList(params)
        .then((list) => {
          console.log(list);
          commit('OPERATORS_REQUEST_SUCCESS');
          commit('CLEAR_MORE_OPERATORS');
          commit('SAVE_LIST', list);
        });
    })
    .catch((e) => {
      commit('OPERATORS_REQUEST_ERROR');
      console.log('err check auth on fetchMails', e);
    });
}

export const fetchMoreOperators = ({ commit, dispatch }, params) => {
  dispatch('CheckAuth', null, {root: true})
    .then(() => {
      GetOperatorsList(params)
        .then((list) => {
          commit('ADD_MORE_OPERATORS', list);
        });
    })
    .catch((e) => {
      console.log(e);
      console.log('err check auth on checkMore', e);
    });
} 

export const alterCustomerStatus =async ({commit,dispatch},params)=>{
  dispatch('CheckAuth',null,{root:true})
    .then(()=>{
      AlterCustomerStatus(params)
      .then((res)=>{
        commit('ALTER_CUSTOMER_STATUS',params);
      })

    })
    .catch((e)=>{
      console.log(e);
      console.log('err check auth on checkMore', e);
    });
}

export const fetchOperatorsCSV = ({ commit, dispatch }, params) => {
  return dispatch('CheckAuth', null, {root: true})
    .then(() => {
      return GetOperatorsListCSV(params)
        .then((list) => {
          return list;
        });
    })
    .catch((e) => {
      console.log('err check auth on fetchMails', e);
    });
}